import { useSearch } from './useSearch';
import { useSearchParams } from 'react-router-dom';
import { useParams } from 'react-router';

export const useCurrentPage = () => {
  const { isSearchActive } = useSearch();
  const [searchParams] = useSearchParams();
  const { page } = useParams();

  if (isSearchActive) {
    const searchPage = searchParams.get('page') ?? '1';
    return parseInt(searchPage, 10);
  }

  return parseInt(page ?? '1', 10);
};
